export const normalizeValues = (values, gaRoleTypes, notApplicable) => {
	let gaParentComponentId;
	if (parseInt(values.groupRole) === gaRoleTypes.component) {
		if (values?.region === notApplicable.id) {
			gaParentComponentId = null;
		} else {
			gaParentComponentId = values?.region;
		}
	} else {
		if (parseInt(values.groupRole) === gaRoleTypes.regional) {
			gaParentComponentId = null;
		}
	}

	let normalized = {
		gaScopeId: values?.scope,
		gaParentComponentId: gaParentComponentId,
		shortName: values.name.trim(),
		pocEmail: values?.internalUser?.allProps.email, //TODO: add external/internal user email, next user story
		pocText: values?.internalUser?.allProps.displayName,
		pocGui: values?.internalUser?.allProps.gui,
		notUsingCanvas: !values?.notUsingCanvas ? false : values.notUsingCanvas,
		referenceOnly: values.referenceOnly,
		gaRoleTypeId: values?.groupRole
	};
	return normalized;
};
